import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class EscalationServices {
    private apiUrl = `${environment.apiUrl}/api/v1`;
    private companyId = global['loginUser'].curCmpnId;

    constructor(private http: Http) {
        this.companyId = global['loginUser'].curCmpnId;
        //this.loginService.getAccessTokenCheck(2);
        // Service 내의 Interceptor 가 안 먹히고 있음...
        // httpInterceptor.request().addInterceptor((data, method) => {
        //     console.log(method, data);
        //     return data;
        // });
    };

    /**
     * escalation
     * escalation list 조회
     * Mothod : Get
     * API No : 5.01
     * /api/v1/{cmpnNo}/escalation
     * **/
    getEscalationList(queryString: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/escalation${queryString}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * escalation
     * escalation detail 조회
     * Mothod : Get
     * API No : 5.02
     * /api/v1/{cmpnNo}/escalation/{escalPlcyNo}
     * **/
    getEscalationInfo(escalPlcyNo: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/escalation/${escalPlcyNo}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * escalation
     * escalation name 수정
     * Mothod : Put
     * API No : 5.03
     * /api/v1/{cmpnNo}/escalation/{escalPlcyNo}/name
     * **/
    modifyEscalPlcyNm(escalPlcyNo: string, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/escalation/${escalPlcyNo}/name`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * escalation
     * escalation detail description 수정
     * Mothod : Put
     * API No : 5.04
     * /api/v1/{cmpnNo}/escalation/{escalPlcyNo}/desc
     * **/
    modifyEscalPlcyDtlDesc(escalPlcyNo: string, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/escalation/${escalPlcyNo}/desc`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * escalation
     * escalation 수정
     * Mothod : Put
     * API No : 5.05
     * /api/v1/{cmpnNo}/escalation/{escalPlcyNo}
     * **/
    modifyEscalPlcy(escalPlcyNo: string, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/escalation/${escalPlcyNo}`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * escalation
     * escalation 수정 가능 여부 조회
     * Mothod : Get
     * API No : 5.06
     * /api/v1/{cmpnNo}/escalation/{escalPlcyNo}/isedit
     * **/
    getEscalEditYn(escalPlcyNo: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/escalation/${escalPlcyNo}/isedit`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * escalation
     * escalation 삭제
     * Mothod : Delete
     * API No : 5.07
     * /api/v1/{cmpnNo}/escalation/{escalPlcyNo}
     * **/
    deleteEscalPlcy(escalPlcyNo: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/escalation/${escalPlcyNo}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * escalation
     * escalation 등록
     * Method : Post
     * API No : 5.08
     * /api/v1/{cmpnNo}/escalation
     * **/
    addEscalPlcy(postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/escalation`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * escalation
     * escalation 등록
     * Method : Post
     * API No : 5.08
     * /api/v1/{cmpnNo}/escalation
     * **/
    getCurrentEscalation(escalPlcyNo: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/escalation/curr/${escalPlcyNo}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/escalation.services.ts